import script from "./ActivityBanner.vue?vue&type=script&setup=true&lang=js"
export * from "./ActivityBanner.vue?vue&type=script&setup=true&lang=js"

import "./ActivityBanner.vue?vue&type=style&index=0&id=010dc5a9&scoped=true&lang=less"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_ab4c17feafb765c6aa70ff6940de3b6b/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-010dc5a9"]])

export default __exports__